import { render, staticRenderFns } from "./ActiveService.vue?vue&type=template&id=46d899af&scoped=true"
import script from "./ActiveService.vue?vue&type=script&lang=js"
export * from "./ActiveService.vue?vue&type=script&lang=js"
import style0 from "./ActiveService.vue?vue&type=style&index=0&id=46d899af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d899af",
  null
  
)

export default component.exports